import { CATEGORIES, ZVANJA, ROLES } from "../data/pravilnik";

export const PrintReport = ({ basic, target, counts, calc, result }) => {
  const zvanje = ZVANJA[target];
  const role = ROLES.find((r) => r.id === basic.role);
  const entered = CATEGORIES.map((cat) => ({
    cat,
    items: cat.items.filter((i) => (Number(counts[i.id]) || 0) > 0),
  })).filter((g) => g.items.length > 0);

  return (
    <div className="print-only" data-testid="print-report">
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Kalkulator napredovanja – izvještaj</h1>
      <p style={{ fontSize: 11, color: "#555", marginBottom: 12 }}>
        Prema Pravilniku o napredovanju (NN 68/2019 i 32/2021) · Izračun je informativan · {new Date().toLocaleDateString("hr-HR")}
      </p>

      <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse", marginBottom: 12 }}>
        <tbody>
          <tr><td style={{ padding: "2px 0", color: "#555" }}>Radno mjesto</td><td style={{ fontWeight: 600 }}>{role?.label}</td></tr>
          <tr><td style={{ padding: "2px 0", color: "#555" }}>Ciljano zvanje</td><td style={{ fontWeight: 600 }}>{zvanje.label}</td></tr>
          <tr><td style={{ padding: "2px 0", color: "#555" }}>Godine staža</td><td style={{ fontWeight: 600 }}>{basic.staz || 0}</td></tr>
          <tr><td style={{ padding: "2px 0", color: "#555" }}>Sati usavršavanja (posljednjih 5 god.)</td><td style={{ fontWeight: 600 }}>{basic.kpr || 0}</td></tr>
          {zvanje.prev && (
            <tr><td style={{ padding: "2px 0", color: "#555" }}>Godine u zvanju {zvanje.prev.zvanje}</td><td style={{ fontWeight: 600 }}>{basic.prevYears || 0}</td></tr>
          )}
          <tr><td style={{ padding: "2px 0", color: "#555" }}>Ukupno bodova</td><td style={{ fontWeight: 700 }}>{calc.total} / {result.neededPoints}</td></tr>
        </tbody>
      </table>

      <h2 style={{ fontSize: 14, fontWeight: 700, margin: "10px 0 4px" }}>Provjera uvjeta</h2>
      <table style={{ width: "100%", fontSize: 12, borderCollapse: "collapse", marginBottom: 12 }}>
        <tbody>
          {result.checks.map((c) => (
            <tr key={c.id} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "3px 0", width: 20 }}>{c.ok ? "✓" : "✗"}</td>
              <td style={{ padding: "3px 0" }}>{c.label}</td>
              <td style={{ padding: "3px 0", textAlign: "right", fontWeight: 600 }}>{c.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ fontSize: 13, fontWeight: 700, marginBottom: 12 }}>
        {result.eligible
          ? `Prema unesenim podacima ispunjeni su uvjeti za zvanje: ${zvanje.label}.`
          : `Prema unesenim podacima uvjeti za zvanje ${zvanje.label} još nisu ispunjeni.`}
      </p>

      {entered.length > 0 && (
        <>
          <h2 style={{ fontSize: 14, fontWeight: 700, margin: "10px 0 4px" }}>Unesene aktivnosti</h2>
          {entered.map(({ cat, items }) => (
            <div key={cat.id} style={{ marginBottom: 8 }}>
              <p style={{ fontSize: 12, fontWeight: 700, margin: "4px 0" }}>
                {cat.title}: {calc.byCategory[cat.id]} bodova
              </p>
              <table style={{ width: "100%", fontSize: 11, borderCollapse: "collapse" }}>
                <tbody>
                  {items.map((i) => (
                    <tr key={i.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
                      <td style={{ padding: "2px 0" }}>{i.label}</td>
                      <td style={{ padding: "2px 0", textAlign: "center", width: 40 }}>× {Number(counts[i.id])}</td>
                      <td style={{ padding: "2px 0", textAlign: "right", width: 50, fontWeight: 600 }}>
                        {Number(counts[i.id]) * i.points} bd
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </>
      )}
    </div>
  );
};
